import { Box, Fade, IconButton, Typography } from '@mui/material'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import EmailIcon from '@mui/icons-material/Email'
import { toast } from 'react-toastify'

const email = "crrodrigues2001@outlook.com.br"

const Contact = () => {
  return (
    <Fade in={true} timeout={1000}>
      <Box
        height={'100%'}
        width={'90%'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Typography variant="h4" gutterBottom>
          Você pode entrar em contato comigo através dos seguintes canais
        </Typography>
        <Box width={'100%'} display={'flex'} justifyContent={'center'}>
          <IconButton
            aria-label="repository"
            size="large"
            href="https://www.linkedin.com/in/christian-r-rodrigues/"
          >
            <LinkedInIcon fontSize="large" />
          </IconButton>
          <IconButton
            aria-label="repository"
            size="large"
            href="https://wa.me/5511944602063"
          >
            <WhatsAppIcon fontSize="large" />
          </IconButton>
          <IconButton
            aria-label="repository"
            size="large"
            href={`mailto:${email}`}
            onClick={() => {
              navigator.clipboard.writeText(email)
              toast.info('E-mail copiado para a área de transferência!')
            }}
          >
            <EmailIcon fontSize="large" />
          </IconButton>
        </Box>
      </Box>
    </Fade>
  )
}

export default Contact
